import { useQuery } from '@tanstack/react-query';

import { marketingKeys } from '@/hooks/league/marketingKeys';
import { getHpMarketing } from '@/infrastructure/network/data/homepage/team-leagues';

export const useMarketingInfoQuery = (hpMarketingType: string) => {
	return useQuery({
		queryKey: marketingKeys.marketingInfo(hpMarketingType),
		queryFn: () => getHpMarketing({ hpMarketingType })
	});
};
